import { render, staticRenderFns } from "./AruFileInput.vue?vue&type=template&id=23251566&"
import script from "./AruFileInput.vue?vue&type=script&lang=js&"
export * from "./AruFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports